<div *ngIf="SolicitanteLogado(); then vercitas; else logarse"></div>

<!-- IDENTIFICACIÓN PARA CONSULTA DE CITAS PREVIAS -->
<ng-template #logarse>
  <div class="capa-home">
    <h1 class="titulo">Ver mis citas</h1>

    <form #frmSolicitante="ngForm" (ngSubmit)="onSubmitSolicitante()">
      <label><b>Documento identificativo</b></label>
      <input
        name="dni"
        type="text"
        maxlength="15"
        style="text-transform: uppercase"
        [(ngModel)]="sFiltroNIF"
        placeholder="* NIF, DNI, CIF, tarjeta residencia, nº pasaporte, ..."
        required
      />
      <span
        *ngIf="
          frmSolicitante.submitted && frmSolicitante.controls['dni'].errors
        "
        class="msgerror"
        >Documento identificativo obligatorio</span
      >

      <label><b>Email</b></label>
      <input
        name="email"
        type="email"
        maxlength="100"
        style="text-transform: lowercase"
        [(ngModel)]="sFiltroEMAIL"
        placeholder="* Email"
        required
      />
      <span
        *ngIf="
          frmSolicitante.submitted &&
          (frmSolicitante.controls['email'].errors || !emailvalido)
        "
        class="msgerror"
        >Email obligatorio o no válido</span
      >

      <label><b>Nº Ticket de la cita</b></label>
      <input
        name="ticket"
        maxlength="7"
        style="text-transform: uppercase"
        type="text"
        [(ngModel)]="sTICKET"
        placeholder="* Nº de ticket"
        required
      />
      <span
        *ngIf="
          frmSolicitante.submitted && frmSolicitante.controls['ticket'].errors
        "
        class="msgerror"
        >Ticket obligatorio</span
      >

      <div class="btn-grupo">
        <button type="submit" class="btn-general">
          <span>Identificarme</span>
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- cONSULTA DE CITAS PREVIAS -->
<ng-template #vercitas>
  <div class="capa-home">
    <h1 class="titulo">Mis citas pendientes</h1>

    <mat-accordion #acordeon="matAccordion">
      <mat-expansion-panel
        *ngFor="let oDetalleCita of aDetalleCitas; let i = index"
        [expanded]="i === 0"
        (opened)="panelOpenState = true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ oDetalleCita.FECHA_HORA_CITA }}
          </mat-panel-title>
          <mat-panel-description>
            {{ oDetalleCita.ticket }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="resumen-cita" *ngIf="oDetalleCita.id_cita > 0">
          <div class="btn-header">
            <i
              class="far fa-envelope"
              (click)="ReenviarCita(i)"
              title="Reenviar Email"
            ></i>
            <i
              class="fas fa-print"
              (click)="ImprimirCita(i)"
              title="Imprimir"
            ></i>
          </div>

          <p>
            <i class="fas fa-user-tag" title="Área"></i>
            <span>{{ oDetalleCita.AREA }}</span>
          </p>

          <p>
            <i class="far fa-calendar" title="Fecha"></i>
            <span>{{ oDetalleCita.FECHA_HORA_CITA }}</span>
          </p>

          <p>
            <i class="far fa-file-alt" title="Trámite"></i>
            <span>{{ oDetalleCita.TRAMITE }}</span>
          </p>
          <p *ngIf="oDetalleCita.telematica">
            <i class="fas fa-camera" title="Enlace"></i>
            <a [href]="oDetalleCita.url_video_solicitante"
              >Enlace cita telemática</a
            >
          </p>

          <div class="mensaje">
            <p
              *ngIf="oDetalleCita.INFO_TRAMITE !== ''"
              [innerHTML]="oDetalleCita.INFO_TRAMITE"
            ></p>
            <p>Documentación que debe aportar:</p>
            <ul>
              <li *ngFor="let sDoc of oDetalleCita.DOCUMENTACION">
                {{ sDoc }}
              </li>
            </ul>
          </div>

          <p class="titulo-info-adicional">Información del solicitante:</p>

          <table>
            <tr>
              <td>Código Identidad:</td>
              <td>{{ oDetalleCita.SOLICITANTE_NIF }}</td>
            </tr>
            <tr>
              <td>Solicitante:</td>
              <td>{{ oDetalleCita.SOLICITANTE }}</td>
            </tr>
            <tr>
              <td>Teléfono Móvil:</td>
              <td>{{ oDetalleCita.SOLICITANTE_TLF1 }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.SOLICITANTE_TLF2 != null &&
                oDetalleCita.SOLICITANTE_TLF2 != undefined &&
                oDetalleCita.SOLICITANTE_TLF2 !== ''
              "
            >
              <td>Teléfono Fijo:</td>
              <td>{{ oDetalleCita.SOLICITANTE_TLF2 }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td>{{ oDetalleCita.SOLICITANTE_EMAIL }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.MOTIVO_CITA != null &&
                oDetalleCita.MOTIVO_CITA != undefined &&
                oDetalleCita.MOTIVO_CITA !== ''
              "
            >
              <td>Motivo cita:</td>
              <td>{{ oDetalleCita.MOTIVO_CITA }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.REPRESENTADO_NIF != null &&
                oDetalleCita.REPRESENTADO_NIF != undefined &&
                oDetalleCita.REPRESENTADO_NIF !== ''
              "
            >
              <td></td>
              <td>
                <i
                  >* Actúa en representación de {{ sEnRepresentacionDe }} con
                  código identidad {{ oDetalleCita.REPRESENTADO_NIF }}</i
                >
              </td>
            </tr>
          </table>

          <button class="btn cancelar center" (click)="ConfirmarAnulacion(i)">
            Anular Cita
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-template>
